import api from '@/api/_medical-activity'

export default {
    name: 'MedicalActivityPanel',
    props: {
        initialStart: { type: String, required: true }, initialEnd: { type: String, required: true },
        timezone: { type: String, required: true }
    },
    data() {
        return {
            startDate: this.initialStart, endDate: this.initialEnd, serviceId: '', category: '', search: '',
            selected: null, tab: 'events', page: 1, listPage: 1, result: null, services: [],
            loading: false, error: '', sequence: 0,
            tabs: [{ id: 'events', label: 'Chronologie' }, { id: 'patients', label: 'Patients / consultations' }, { id: 'summary', label: 'Synthèse' }],
            categories: [{ id: 'dossier', label: 'Dossier médical' }, { id: 'prescription', label: 'Prescriptions' },
                { id: 'consultation', label: 'Consultations' }, { id: 'resultat', label: 'Résultats' },
                { id: 'parcours', label: 'Parcours patient' }, { id: 'kine', label: 'Kiné' }, { id: 'vaccination', label: 'Vaccination' }],
            sourceLabels: { consultation_history: 'Dossier et demandes', prescription: 'Ordonnances', consultation: 'Consultations',
                resultat: 'Résultats', avis_requested: 'Demandes d’avis', avis_answered: 'Réponses aux avis', reference: 'Références', movements: 'Transferts',
                cca_kine_course_revisions: 'Prises en charge Kiné', cca_kine_clinical_history: 'Séances et réévaluations Kiné', vaccination: 'Vaccination', document_reads: 'Lectures et impressions' }
        }
    },
    computed: {
        coverage() { return this.result ? (this.result.coverage || (this.result.meta && this.result.meta.coverage) || []) : [] },
        pages() { return Math.max(1, Math.ceil((this.result && this.result.meta && this.result.meta.total || 0) / 25)) }
    },
    mounted() { this.load() },
    beforeDestroy() { this.sequence += 1 },
    methods: {
        displayDate(value) {
            if (!value) return '—'
            try { return new Intl.DateTimeFormat('fr-FR', { dateStyle: 'short', timeStyle: 'short', timeZone: this.timezone }).format(new Date(value)) }
            catch (_) { return 'Date indisponible' }
        },
        categoryLabel(value) { return (this.categories.find(c => c.id === value) || {}).label || 'Autre activité' },
        coverageLabel(value) { return ({ available: 'Raccordé', partial: 'Partiel', unavailable: 'Non raccordé / indisponible', not_traced: 'Non tracé' })[value] || value },
        openDoctor(doctor) { this.listPage = this.page; this.selected = doctor; this.tab = 'events'; this.page = 1; this.load() },
        back() { this.selected = null; this.page = this.listPage; this.category = ''; this.load() },
        changeTab(tab) { this.tab = tab; this.page = 1; this.load() },
        filter() { this.page = 1; this.load() },
        goPage(page) { this.page = page; this.load() },
        async load() {
            const sequence = ++this.sequence
            this.error = ''; this.result = null; this.loading = false
            if (!this.startDate || !this.endDate || this.startDate > this.endDate) {
                this.error = 'Choisissez des dates valides dans l’ordre chronologique.'; return
            }
            this.loading = true
            const params = { start_date: this.startDate, end_date: this.endDate, page: this.page, per_page: 25 }
            if (this.serviceId) params.service_id = this.serviceId
            if (this.selected && this.category) params.category = this.category
            if (!this.selected && this.search.trim()) params.q = this.search.trim()
            const path = this.selected ? 'practitioners/' + this.selected.id + '/' + this.tab : 'practitioners'
            try {
                const response = await api.read(path, params)
                if (sequence !== this.sequence) return
                this.result = response
                if (response.services) this.services = response.services
            } catch (error) {
                if (sequence !== this.sequence) return
                const status = error.response && error.response.status
                this.error = status === 401 || status === 403 ? 'Accès refusé : utilisez un rôle administrateur actif dans cet établissement.'
                    : status === 404 ? 'Le suivi des activités n’est pas activé sur ce serveur.'
                    : status === 422 ? 'Vérifiez les filtres : la période doit être limitée à 366 jours.'
                    : 'Les activités n’ont pas pu être chargées. Réessayez ; aucune valeur n’a été remplacée par zéro.'
            } finally { if (sequence === this.sequence) this.loading = false }
        }
    }
}
